export const TOWN_REPORTS = [
  {
    "title": "Summary of Revenues and Appropriations/Expenditures",
    "id": "town-combined-summary-heading"
  },
  {
    "title": "Summary of Revenues and Transfers",
    "id": "town-revenue-summary-heading"
  },
  {
    "title": "Summary of Expenditures and Transfers",
    "id": "town-expenditure-summary-heading"
  },
  {
    "title": "Fund Balance and Estimated Operational Results",
    "id": "town-fund-balance-heading"
  },
  {
    "title": "Tax Revenues",
    "id": "town-tax-revenues-heading"
  },
  {
    "title": "Licenses & Permits",
    "id": "town-licenses-permits-heading"
  },
  {
    "title": "Intergovernmental",
    "id": "town-intergovernmental-heading"
  },
  {
    "title": "Charges for Services",
    "id": "town-charges-for-services-heading"
  },
  {
    "title": "Other Revenues",
    "id": "town-other-revenues-heading"
  },
  {
    "title": "Transfers In",
    "id": "town-transfers-in-heading"
  },
  {
    "title": "Town",
    "id": "town-town-heading"
  },
  {
    "title": "Debt Service & Transfers Out",
    "id": "town-debt-service-transfers-out-heading"
  }
];
